module["exports"] = {
  "adjective": [
    "Pequeno",
    "Ergonômico",
    "Rústico",
    "Inteligente",
    "Lindo",
    "Incrível",
    "Fantástico",
    "Prático",
    "Lustroso",
    "Impressionante",
    "Genérico",
    "Feito à mão",
    "Licenciado",
    "Refinado",
    "Sem marca",
    "Gostoso"
  ],
  "material": [
    "Aço",
    "Madeira",
    "Concreto",
    "Plástico",
    "Algodão",
    "Granito",
    "Borracha",
    "Metal",
    "Macio",
    "Fresco",
    "Congelado"
  ],
  "product": [
    "Cadeira",
    "Carro",
    "Computador",
    "Teclado",
    "Mouse",
    "Bicicleta",
    "Bola",
    "Luvas",
    "Calças",
    "Camiseta",
    "Mesa",
    "Sapatos",
    "Chapéu",
    "Toalhas",
    "Sabonete",
    "Atum",
    "Frango",
    "Peixe",
    "Queijo",
    "Bacon",
    "Pizza",
    "Salada",
    "Salsicha",
    "Salgadinhos"
  ]
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/pt_BR/commerce/product_name.js
// module id = 3395
// module chunks = 1609